import { Injectable } from '@angular/core'

import { ExtratoDeAntecipacoes } from '../../../pkw-data/collect/extrato/extrato-de-antecipacoes.model'
import { ListaPaginada, Pagina } from '../../../pkw-data/core/util/lista-paginada.model'
import { PkwDatastore } from '../../../pkw-data/pkw-datastore'

@Injectable()
export class ExtratoDeAntecipacoesService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obter(id: string) {
        return this.pkwDatastore.findRecord(ExtratoDeAntecipacoes, id)
    }

    pesquisar(filtro: any, indicePagina?: number, tamanhoPagina?: number) {
        const pagina = new Pagina(indicePagina, tamanhoPagina)

        return this.pesquisarPaginado(filtro, pagina)
    }

    pesquisarPaginado(filtro: any, pagina: Pagina) {
        const params = {
            filter: filtro,
            page: pagina.toLimitOffset()
        }

        return this.pkwDatastore
            .findAll(ExtratoDeAntecipacoes, params)
            .map(
                reponse =>
                    new ListaPaginada<ExtratoDeAntecipacoes>(
                        reponse.getModels(),
                        pagina.indice,
                        pagina.tamanho,
                        reponse.getMeta().meta.totalResourceCount
                    )
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-antecipacoes/shared/extrato-de-antecipacoes.service.ts